module.exports = __webpack_public_path__ + "media/images/gallery/constellations/crater/crt_lines-0ff02c672c7e9ff02efb909ba47666a9.gif";